{
  "build": "latest",
  "domain": "dev-6ithxdcdoloa1j1y.eu.auth0.com",
  "clientId": "MtsebxWMhMqakdtBFF5LkAtm8ZU48puB",
  "authorizationParams": {
    "audience": "tinarm-strongarm"
  },
  "geometriesUri": "https://geometries.ltc.tinarmengineering.com",
  "windingUri": "https://operations.ltc.tinarmengineering.com",
  "apiUri": "https://api.ltc.tinarmengineering.com",
  "visUri": "https://vis.ltc.tinarmengineering.com",
  "fmedaApiUri": "https://fmeda-api.ltc.tinarmengineering.com",
  "queueUri": "wss://queue.ltc.tinarmengineering.com:15671",
  "queueUser": "taequeue",
  "queuePass": "UrsaMin0r",
  "errorPath": "/error"
}
